import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ReactTable from 'react-table';

import Link from 'comps/link';
import { Text, Button, Separator, FlexView } from '@cuemath/comps';
import { tableColumns } from './constants/constants';
import COLORS from 'constants/colors';

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;
const Wrapper = styled(FlexView)`
  @media (min-width: 767px) {
    margin: 50px auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Label = styled(FlexView)`
  width: 50%;
  flex-direction: row;
`;

const LeadLabel = styled.div`
  padding: 4px;
  ${({ leadType }) =>
    leadType === 'primary'
      ? css`
          background-color: ${COLORS.YELLOW};
        `
      : css`
          background-color: ${COLORS.LIGHT_GREEN};
        `}
  font-weight: bold;
  border-radius: 2px;
  margin-right: 20px;
`;

function StudentList({ studentLeads, parentId, parentPhone }) {
  const getTrProps = (state, rowInfo) => {
    if (rowInfo) {
      return {
        style: {
          'background-color':
            rowInfo.original.Phone === null
              ? `${COLORS.LIGHT_GREEN}`
              : `${COLORS.YELLOW}`,
        },
      };
    }
    return {
      style: {
        'background-color': `${COLORS.WHITE}`,
      },
    };
  };

  return (
    <section>
      <Separator height={20} transparent />
      <Text size="medium" weight="bolder">
        Parent&apos;s Children
      </Text>
      <Separator height={20} transparent />
      <Label>
        <LeadLabel leadType="primary">Primary Lead</LeadLabel>
        <LeadLabel leadType="secondary">Sibling Lead</LeadLabel>
      </Label>
      <Separator height={20} transparent />
      <React.Fragment>
        <TableWrapper>
          <ReactTable
            data={studentLeads}
            className="-striped -highlight"
            showPageSizeOptions={false}
            sortable={true}
            resizable={true}
            defaultPageSize={10}
            columns={tableColumns}
            style={{ textAlign: 'center' }}
            showPagination={true}
            getTrProps={getTrProps}
          />
        </TableWrapper>
      </React.Fragment>
      <Wrapper>
        <Link to={`/parent-student/${parentId}/student?phoneNumber=${parentPhone}`}>
          <Button label="Add a new child" />
        </Link>
      </Wrapper>
    </section>
  );
}
StudentList.propTypes = {
  students: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  parentId: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
};

export default StudentList;
